import React from 'react'

import Modal from '../../../../../../components/structure/Modal'

const SeeMoreModal = ({ ...props }) => {
  return (
    <Modal {...props} width="64rem">
      Teste
    </Modal>
  )
}

export default SeeMoreModal
